(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-detail-content')) {
    customElements.define('product-detail-content', class ProductDetailContent extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced === 'true') return;
        const children = Array.from(this.children);
        const isGroupHeading = (node) => {
          if (/^H[2-4]$/.test(node.tagName)) return true;
          if (node.tagName !== 'P') return false;
          const meaningfulNodes = Array.from(node.childNodes).filter((child) => {
            return child.nodeType !== Node.TEXT_NODE || child.textContent.trim() !== '';
          });
          if (meaningfulNodes.length !== 1) return false;
          const emphasis = node.firstElementChild;
          return Boolean(emphasis && (emphasis.tagName === 'STRONG' || emphasis.tagName === 'B'));
        };
        if (children.filter(isGroupHeading).length < 2) return;

        const fragment = document.createDocumentFragment();
        let group = null;
        children.forEach((node) => {
          if (isGroupHeading(node)) {
            group = document.createElement('section');
            group.className = 'product-description__group';
            const heading = document.createElement('h3');
            heading.textContent = node.textContent.trim();
            group.append(heading);
            fragment.append(group);
            return;
          }
          if (group) {
            group.append(node);
          } else {
            fragment.append(node);
          }
        });
        this.replaceChildren(fragment);
        this.dataset.enhanced = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url || this.dataset.loaded === 'true') return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        }, { rootMargin: '500px 0px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        if (!this.hasAttribute('data-ready')) delete this.dataset.loaded;
      }

      async load() {
        this.dataset.loaded = 'true';
        this.controller?.abort();
        this.controller = new AbortController();
        const controller = this.controller;
        let timedOut = false;
        const timeout = setTimeout(() => {
          timedOut = true;
          controller.abort();
        }, 12000);
        try {
          const response = await fetch(this.dataset.url, { headers: { Accept: 'text/html' }, signal: controller.signal });
          if (!response.ok) throw new Error('Recommendations unavailable');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = documentFragment.querySelector('product-recommendations');
          if (!source || !source.querySelector('[data-recommendations-content]')) {
            this.hidden = true;
            return;
          }
          const compared = new Set([...document.querySelectorAll('.style-comparison__product')].map((link) => new URL(link.href).pathname.split('/').filter(Boolean).pop()));
          const limit = Math.min(4, Number(this.dataset.productsToShow) || 4);
          const seen = new Set();
          let visibleCount = 0;
          source.querySelectorAll('.product-recommendations__grid > li').forEach((item) => {
            const card = item.querySelector('[data-product-card]');
            const handle = card?.dataset.productHandle;
            if (!handle || compared.has(handle) || seen.has(handle) || visibleCount >= limit) {
              item.remove();
              return;
            }
            seen.add(handle);
            visibleCount += 1;
          });
          if (visibleCount < 2) {
            this.hidden = true;
            return;
          }
          if (!this.isConnected || controller.signal.aborted) return;
          this.dataset.visibleCount = String(visibleCount);
          this.innerHTML = source.innerHTML;
          this.hidden = false;
          this.setAttribute('data-ready', '');
          window.Northyard?.initProductCards?.(this);
        } catch (error) {
          if (error.name === 'AbortError' && !timedOut) return;
          this.hidden = true;
        } finally {
          clearTimeout(timeout);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-review-disclosures')) {
    customElements.define('product-review-disclosures', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.sequence = this.sequence || 0;
        this.reviewListStates ||= new WeakMap();
        this.reviewBodyStates ||= new WeakMap();
        this.addEventListener('click', (event) => {
          const listButton = event.target.closest('[data-ny-review-list-toggle]');
          if (listButton && this.contains(listButton)) {
            const widget = listButton.closest('.jdgm-rev-widg, .jdgm-widget-revamp');
            const list = widget && this.reviewList(widget);
            const state = list && this.reviewListStates.get(list);
            if (!state) return;
            const firstRevealed = state.nodes.find((review) => review.dataset.nyReviewDeferred === 'true');
            state.expanded = !state.expanded;
            this.enhance();
            if (state.expanded && firstRevealed) this.focusReview(firstRevealed);
            if (!state.expanded && listButton.getBoundingClientRect().top < 100) {
              listButton.scrollIntoView({ block: 'center', behavior: 'instant' });
            }
            return;
          }
          const button = event.target.closest('[data-ny-review-toggle], [data-ny-distribution-toggle]');
          if (!button || !this.contains(button)) return;
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expanded));
          if (button.hasAttribute('data-ny-review-toggle')) {
            button.parentElement.dataset.nyCollapsed = String(!expanded);
            button.textContent = expanded ? this.dataset.hideReview : this.dataset.readReview;
            // Collapsing a long review must not leave its focused control above the viewport.
            if (!expanded && button.getBoundingClientRect().top < 100) {
              button.scrollIntoView({ block: 'center', behavior: 'instant' });
            }
          } else {
            const histogram = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
            if (histogram) histogram.dataset.nyExpanded = String(expanded);
            button.textContent = expanded ? this.dataset.hideDistribution : this.dataset.showDistribution;
          }
        }, { signal: this.events.signal });
        this.addEventListener('click', (event) => {
          const body = event.target.closest('.jm-review-content[data-ny-disclosure-ready] .jm-review-content__body');
          if (body && this.contains(body)) event.stopPropagation();
        }, { capture: true, signal: this.events.signal });
        this.observer = new MutationObserver(() => this.schedule());
        this.resizeObserver = new ResizeObserver(([entry]) => {
          const rootSize = getComputedStyle(document.documentElement).fontSize;
          if (entry.contentRect.width === this.observedWidth && rootSize === this.observedRootSize) return;
          this.observedWidth = entry.contentRect.width;
          this.observedRootSize = rootSize;
          this.schedule();
        });
        this.resizeObserver.observe(this);
        document.fonts.ready.then(() => this.schedule());
        document.fonts.addEventListener('loadingdone', () => this.schedule(), { signal: this.events.signal });
        this.enhance();
      }

      schedule() {
        if (this.frame || !this.isConnected) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected) this.enhance();
        });
      }

      disconnectedCallback() {
        this.querySelectorAll('[data-ny-temporary-focus]').forEach((review) => this.clearReviewFocus(review));
        this.querySelectorAll('[data-ny-star-size], [data-ny-header-stacked]').forEach((header) => {
          header.removeAttribute('data-ny-star-size');
          header.removeAttribute('data-ny-header-stacked');
        });
        this.events?.abort();
        this.events = null;
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.observedWidth = null;
        this.observedRootSize = null;
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      focusReview(review) {
        if (!review.hasAttribute('tabindex')) {
          review.tabIndex = -1;
          review.setAttribute('data-ny-temporary-focus', '');
          review.addEventListener('blur', () => this.clearReviewFocus(review), { once: true, signal: this.events.signal });
        }
        review.focus({ preventScroll: true });
      }

      clearReviewFocus(review) {
        if (!review.hasAttribute('data-ny-temporary-focus')) return;
        if (review.getAttribute('tabindex') === '-1') review.removeAttribute('tabindex');
        review.removeAttribute('data-ny-temporary-focus');
      }

      controlId(element) {
        if (!element.id) {
          this.sequence += 1;
          element.id = `${this.closest('.shopify-section')?.id || 'product-reviews'}-disclosure-${this.sequence}`;
        }
        return element.id;
      }

      makeToggle(label, attribute, ids) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ny-review-toggle';
        button.setAttribute(attribute, '');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', ids.join(' '));
        button.textContent = label;
        return button;
      }

      reviewList(widget) {
        return widget.querySelector('.jdgm-rev-widg__body > .jdgm-rev-widg__reviews, .jdgm-review-list');
      }

      enhanceReviewList(widget) {
        const list = this.reviewList(widget);
        const reviews = list ? [...list.children].filter((node) => node.matches('.jdgm-rev, .jm-review-item')) : [];
        if (!list || reviews.length !== list.children.length) {
          widget.querySelectorAll('[data-ny-review-deferred], [data-ny-pagination-deferred]').forEach((node) => {
            node.removeAttribute('data-ny-review-deferred');
            node.removeAttribute('data-ny-pagination-deferred');
          });
          widget.querySelectorAll('[data-ny-review-list-toggle]').forEach((button) => button.remove());
          return;
        }
        const keys = reviews.map((node) => node.getAttribute('review-uuid') || node.dataset.reviewId || node.querySelector('.jdgm-rev__body, .jm-review-content__body')?.textContent);
        let state = this.reviewListStates.get(list);
        if (!state || reviews.length !== state.nodes.length || reviews.some((node, index) => node !== state.nodes[index] || keys[index] !== state.keys[index])) {
          const appended = state && reviews.length > state.nodes.length && state.nodes.every((node, index) => reviews[index] === node && keys[index] === state.keys[index]);
          state = { nodes: reviews, keys, expanded: Boolean(appended && state.expanded) };
          this.reviewListStates.set(list, state);
        }
        const limit = Math.max(1, Math.min(5, Number.parseInt(this.dataset.initialReviews, 10) || 3));
        const hasMore = reviews.length > limit;
        const collapsed = hasMore && !state.expanded;
        reviews.forEach((review, index) => {
          review.dataset.nyReviewDeferred = String(collapsed && index >= limit);
        });
        widget.querySelectorAll('.jdgm-paginate, .jm-pagination-controls').forEach((pagination) => {
          pagination.dataset.nyPaginationDeferred = String(collapsed);
        });
        let button = list.parentElement.querySelector(':scope > [data-ny-review-list-toggle]');
        if (!hasMore) { button?.remove(); return; }
        if (!button) {
          button = this.makeToggle(this.dataset.showMoreReviews, 'data-ny-review-list-toggle', [this.controlId(list)]);
          button.classList.add('ny-review-list-toggle');
          list.after(button);
        }
        button.hidden = false;
        button.setAttribute('aria-controls', this.controlId(list));
        button.setAttribute('aria-expanded', String(state.expanded));
        const remaining = reviews.length - limit;
        const moreLabel = (remaining === 1 ? this.dataset.showOneReview : this.dataset.showMoreCount) || this.dataset.showMoreReviews;
        button.textContent = state.expanded ? this.dataset.showFewerReviews : moreLabel.replace('[count]', String(remaining));
      }

      alignReviewHeaders(widget) {
        const mobile = matchMedia('(max-width: 749px)').matches;
        const rootSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        widget.querySelectorAll('.jdgm-rev__header').forEach((header) => {
          header.removeAttribute('data-ny-star-size');
          header.removeAttribute('data-ny-header-stacked');
          if (!mobile || !header.getBoundingClientRect().width) return;
          const profile = header.querySelector(':scope > .jdgm-row-profile');
          const rating = header.querySelector(':scope > .jdgm-row-rating');
          const author = profile?.querySelector('.jdgm-rev__author');
          if (!author || !rating) return;
          const icon = profile.querySelector('.jdgm-rev__icon');
          const iconWidth = icon?.getBoundingClientRect().width || 0;
          const minimumProfileWidth = (iconWidth ? iconWidth + 8 : 0) + rootSize * 3;
          for (const size of [13, 12]) {
            if (author.getClientRects().length <= 1 && profile.clientWidth >= minimumProfileWidth && rating.scrollWidth <= rating.clientWidth + 1) break;
            header.dataset.nyStarSize = String(size);
          }
          if (profile.clientWidth < minimumProfileWidth || header.scrollWidth > header.clientWidth + 1) {
            header.setAttribute('data-ny-header-stacked', '');
          }
        });
      }

      enhance() {
        this.observer.disconnect();
        this.querySelectorAll('.jdgm-rev-widg, .jdgm-widget-revamp').forEach((widget) => {
          this.enhanceReviewList(widget);
          this.alignReviewHeaders(widget);
          const summary = widget.querySelector('.jdgm-rev-widg__summary-inner') || widget.querySelector('.jdgm-rev-widg__summary');
          const rating = widget.dataset.averageRating;
          const count = widget.dataset.numberOfReviews;
          widget.querySelectorAll('.ny-review-score, .ny-review-count').forEach((value) => {
            if (value.parentElement !== summary) value.remove();
          });
          widget.querySelectorAll('[data-ny-compact-summary]').forEach((node) => node.removeAttribute('data-ny-compact-summary'));
          if (summary && rating && count && Number(rating) > 0 && Number(rating) <= 5 && Number.isInteger(Number(count)) && Number(count) > 0) {
            const countTemplate = Number(count) === 1 ? this.dataset.reviewCountOne : this.dataset.reviewCountOther;
            [['ny-review-score', rating], ['ny-review-count', countTemplate.replace('[count]', count)]].forEach(([className, text]) => {
              let value = summary.querySelector(`.${className}`);
              if (!value) {
                value = document.createElement('span');
                value.className = className;
                summary.append(value);
              }
              value.textContent = text;
            });
            summary.setAttribute('data-ny-compact-summary', '');
          } else {
            summary?.querySelectorAll('.ny-review-score, .ny-review-count').forEach((value) => value.remove());
          }
          widget.querySelectorAll('[data-ny-distribution-toggle]').forEach((button) => {
            if (!widget.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`)) button.remove();
          });
          widget.querySelectorAll('.jdgm-histogram').forEach((histogram) => {
            const id = this.controlId(histogram);
            const existing = this.querySelector(`[data-ny-distribution-toggle][aria-controls="${CSS.escape(id)}"]`);
            if (existing) {
              histogram.dataset.nyExpanded = existing.getAttribute('aria-expanded');
              return;
            }
            if (!histogram.querySelector('.jdgm-histogram__row[data-rating="5"]')) return;
            const button = this.makeToggle(this.dataset.showDistribution, 'data-ny-distribution-toggle', [id]);
            histogram.before(button);
            histogram.dataset.nyExpanded = 'false';
          });
          widget.querySelectorAll('.jdgm-rev__content, .jm-review-content').forEach((content) => {
            const body = content.querySelector(':scope > .jdgm-rev__body, :scope > .jm-review-body-wrapper > .jm-review-content__body');
            let button = content.querySelector(':scope > [data-ny-review-toggle]');
            const review = content.closest('.jm-review-item, .jdgm-rev');
            const key = review?.getAttribute('review-uuid') || review?.dataset.reviewId;
            const previous = this.reviewBodyStates.get(content);
            const text = body?.textContent || '';
            const unchanged = previous?.body === body && previous?.key === key && previous?.text === text;
            const expanded = unchanged && button?.getAttribute('aria-expanded') === 'true';
            this.reviewBodyStates.set(content, { body, key, text });
            content.removeAttribute('data-ny-collapsed');
            // Leave app-owned media, links and any native Read more controls fully accessible.
            if (!body?.textContent.trim() || body.querySelector('img, video, audio, iframe, a, button, input, select, textarea, details, [tabindex], [role="button"], .jdgm-rev__pics, .jdgm-rev__vids')) {
              button?.remove();
              content.removeAttribute('data-ny-disclosure-ready');
              return;
            }
            if (!body.getBoundingClientRect().width) {
              if (button) content.dataset.nyCollapsed = String(!expanded);
              return;
            }
            content.setAttribute('data-ny-disclosure-ready', '');
            // Measure actual wrapped content, not character count; retain the original text nodes.
            const fullHeight = body.getBoundingClientRect().height;
            body.setAttribute('data-ny-measuring', '');
            const previewHeight = body.getBoundingClientRect().height;
            body.removeAttribute('data-ny-measuring');
            if (fullHeight <= previewHeight + 1) {
              button?.remove();
              return;
            }
            const id = this.controlId(body);
            if (!button) {
              button = this.makeToggle(this.dataset.readReview, 'data-ny-review-toggle', [id]);
            }
            const anchor = body.closest('.jm-review-body-wrapper') || body;
            if (anchor.nextElementSibling !== button) anchor.after(button);
            button.setAttribute('aria-controls', id);
            button.setAttribute('aria-expanded', String(expanded));
            button.textContent = expanded ? this.dataset.hideReview : this.dataset.readReview;
            content.dataset.nyCollapsed = String(!expanded);
          });
        });
        this.observer.observe(this, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating', 'data-number-of-reviews', 'review-uuid', 'data-review-id', 'class', 'style', 'hidden'] });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
